import { WebToolItem } from './models/web-tool-item';
import { sortByName } from './utils/sort-by-name';
import { NavDropdownComponent } from '../nav-dropdown/nav-dropdown.component';
import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  input,
  Input,
  Output,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { BehaviorSubject, map, shareReplay } from 'rxjs';

@Component({
  selector: 'tmx-web-tools-dropdown',
  standalone: true,
  imports: [CommonModule, NavDropdownComponent],
  templateUrl: './web-tools-dropdown.component.html',
  styleUrls: ['./web-tools-dropdown.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WebToolsDropdownComponent {
  private readonly itemsChange$ = new BehaviorSubject<WebToolItem[]>([]);

  licensedItems$ = this.itemsChange$.pipe(
    map((items) => items.filter((item) => item.licensed && !item.expired)),
    map((items) => sortByName(items)),
    shareReplay({ bufferSize: 1, refCount: true })
  );
  hasLicensedItems$ = this.licensedItems$.pipe(
    map((items) => items.length > 0),
    shareReplay({ bufferSize: 1, refCount: true })
  );
  unlicensedItems$ = this.itemsChange$.pipe(
    map((items) => items.filter((item) => !item.licensed && !item.expired)),
    map((items) => sortByName(items)),
    shareReplay({ bufferSize: 1, refCount: true })
  );
  hasUnlicensedItems$ = this.unlicensedItems$.pipe(
    map((items) => items.length > 0),
    shareReplay({ bufferSize: 1, refCount: true })
  );
  expiredItems$ = this.itemsChange$.pipe(
    map((items) => items.filter((item) => item.expired)),
    map((items) => sortByName(items)),
    shareReplay({ bufferSize: 1, refCount: true })
  );
  hasExpiredItems$ = this.expiredItems$.pipe(
    map((items) => items.length > 0),
    shareReplay({ bufferSize: 1, refCount: true })
  );

  @Input() set webToolItems(value: WebToolItem[]) {
    this.itemsChange$.next(value);
  }
  showChangePassword = input(false);
  showLogout = input(false);

  @Output() logoutEvent = new EventEmitter();
  @Output() changePasswordEvent = new EventEmitter();

  @Output() webToolItemClickEvent = new EventEmitter<WebToolItem>();

  openSite(webToolItem: WebToolItem) {
    window.open(webToolItem.homeUrl, '_blank');
  }

  toggleLearnMore(webToolItem: WebToolItem) {
    webToolItem.showLearnMore = !webToolItem.showLearnMore;
  }

  changePassword() {
    this.changePasswordEvent.next(null);
  }

  logout() {
    this.logoutEvent.next(null);
  }

  handleItemClick(webToolItem: WebToolItem) {
    this.webToolItemClickEvent.next(webToolItem);
  }

  contain(event: Event) {
    event.stopPropagation();
    event.preventDefault();
  }
}
